export let feedbackCharm_ariaLabel = "SBTPoc";
export default {feedbackCharm_ariaLabel};